import axios from 'axios';

const instance = axios.create({ 
    baseURL: process.env.REACT_APP_URL_BASE_CITAS,
    headers: { "X-Api-Key": process.env.REACT_APP_API_KEY_CITAS }
});


const request = {
    get: (url) => instance.get(url),
    post: (url, body) => instance.post(url, body),
    put: (url, body) => instance.put(url, body),
    patch: (url) => instance.patch(url),
    delete: (url) => instance.delete(url)
}

export default request;